<app-progress-dashboard-container [label]="label()">
  <p-table [columns]="columns()" [value]="data()" class="w-full">
    <ng-template #header let-columns>
      <tr>
        @for (col of columns; track col.field) {
          <th>
            {{ col.headerKey | transloco }}
          </th>
        }
      </tr>
    </ng-template>
    <ng-template #body let-rowData let-columns="columns">
      <tr>
        @for (col of columns; track col.field) {
          <td>
            @if (col.directusTranslated) {
              {{ rowData[col.field] | translateDirectus }}
            } @else {
              {{ rowData[col.field] }}
            }
          </td>
        }
      </tr>
    </ng-template>
  </p-table>
</app-progress-dashboard-container>
